
import { DrawNumber } from "./DrawNumber"
import Stack from '@mui/material/Stack'

export const DrawNumbers = ({title, group, numbers}) => {

 
  return (
   
    <div>
        <label style={{fontWeight:'500'}}>{title}</label>
        <Stack direction="row" spacing={2}  flexWrap="wrap"  useFlexGap >

        {
        Array.isArray(numbers) &&
            numbers.map((item) => (
            <DrawNumber play={false} group={group} number={item}/>
        ))
        
        }
        </Stack>
      
    </div> 

  )
}
  